module.exports = __webpack_public_path__ + "static/media/youtubeclone.9da9a4d9.png";